import mrpStyles from './../mrp.json'

const title = {
  fontSizeMobile: '20px',
  lineHeightMobile: '25px',
  fontWeight: '850',
  textTransform: 'uppercase',
  fontSizeDesktop: '24px',
  lineHeightDesktop: '30px',
  color: mrpStyles.colors.PrimaryBlack
}

const cta = {
  fontWeight: '400',
  lineHeight: '17.5px',
  letterSpacing: '0.21px',
  color: mrpStyles.colors.PrimaryBlack
}

const paragraph = {
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '24px',
  color: mrpStyles.colors.PrimaryBlack
}

const loyaltyBanner = {
  title,
  cta,
  paragraph
}

export default loyaltyBanner
